<template>
	<section id="header">
		<Nav/>
		<NavHeader/>
		<NavFooter/>
	</section>
</template>
<script>
import Nav from './components/Nav.vue'
import NavHeader from './components/NavHeader.vue'
import NavFooter from './components/NavFooter.vue'

export default {
  name: 'Header',
  components: {
    Nav,
    NavHeader,
    NavFooter
  }
}
</script>